<mat-radio-button
  [value]="value"
  [color]="color"
  [checked]="checked"
  [disabled]="disabled"
  (change)="onChange($event)"
>
  <div class="flex flex-row gap-[12px] justify-start items-center">
    <vi-icon *ngIf="icon" [name]="icon" [size]="18"></vi-icon>
    <span>{{ label }}</span>
  </div>
</mat-radio-button>
